export const environment = {
  production: true,
  id: 'prod',
  domainId: true,
  cepId: true,
  cpfId: true,
  contaIonDomainOrigin: 'CaronteContaIon',
  contaIonDomainCityOrigin: 'CaronteContaIon',
  contaIonDataOrigin: 'Mobile',
  contaIonPix: 'CaronteContaIon',
  updateRegistration: 'UpdateRegistration',
  registration: 'Registration',
  tokenOriginMock: false,
  caronteLikert: {
    charonId: "n5nuri1k",
    entryPoint: 'https://apicd.cloud.itau.com.br/charon/n5nuri1k',
    encrypted: true,
    initSessionUrl: "https://apicd.cloud.itau.com.br",
    protectedHeader: "Authorization",
    apiKey: btoa('401c6cdc-4970-45c4-a21b-60390ed93868')
  },
  carontePix: {
    charonId: "dxy4i2sg",
    entryPoint: 'https://apicd.cloud.itau.com.br/charon/dxy4i2sg',
    encrypted: true,
    initSessionUrl: "https://apicd.cloud.itau.com.br",
    protectedHeader: ["Authorization"],
    apiKey: btoa('401c6cdc-4970-45c4-a21b-60390ed93868')
  },
  caronteCustodia: {
    charonId: 'csyhc7d3',
    entryPoint: 'https://apicd.cloud.itau.com.br/charon/csyhc7d3',
    encrypted: true,
    initSessionUrl: 'https://apicd.cloud.itau.com.br',
    protectedHeader: 'Authorization',
    apiKey: btoa('401c6cdc-4970-45c4-a21b-60390ed93868'),
  },
  datadog: {
    applicationDataDogID: "bf570316-35d9-4655-aaac-5f81d007ca85",
    clientDatadogToken: "pub54befbf56c01497412d5c743d76ab573",
    externalApplication: true
  },
  ambiente: 'prod'
};

